import { render, staticRenderFns } from "./LocalizationForm.vue?vue&type=template&id=423a027f&scoped=true"
import script from "./LocalizationForm.vue?vue&type=script&lang=js"
export * from "./LocalizationForm.vue?vue&type=script&lang=js"
import style0 from "./LocalizationForm.vue?vue&type=style&index=0&id=423a027f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a027f",
  null
  
)

export default component.exports